import React from "react";
import classNames from "classnames";
import { BtnUi, Heading, DialogUi, Icon } from "~/components";
import styles from "./SignInDialogUi.module.css";
import { useSsoRedirect } from "../../hooks/useSsoRedirect";

export const SignInDialogUi = ({
  onClose,
  onSubmit: onSubmitCb,
  selectedPassions,
  cid,
  redirectUrl = null,
}) => {
  const ssoRedirect = useSsoRedirect(true, redirectUrl);
  const onSubmit = () => {
    try {
      onSubmitCb?.();
    } catch (error) {
      console.error("Error preparing sign-in redirect:", error);
    }
    ssoRedirect(cid);
  };

  return (
    <DialogUi
      onClose={onClose}
      header={
        selectedPassions ?
          <div className={styles.passions}>
            {selectedPassions.slice(0, 4).map((passion, i) => (
              <Icon key={i} name={passion} className={styles.passion} />
            ))}
          </div> : <></>
      }
      body={
        <>
          <Heading
            type="h2"
            className={styles.heading}
            text="Sign In to Save Your Selections"
          />
          <p className={styles.text}>
            Sign in to your Marriott Bonvoy profile to save your selected
            passions.
          </p>
        </>
      }
      footer={
        <>
          <BtnUi
            variant="primary"
            block
            className="custom_click_track"
            data-custom_click_track_value="Auth|Sign in|internal"
            onClick={onSubmit}
          >
            Sign In
          </BtnUi>
          <div className={styles.signUpWrapper}>
            <a
              className={classNames(styles.signUpLink, "custom_click_track")}
              data-custom_click_track_value="Auth|Sign up|internal"
              href="https://www.marriott.com/loyalty/createAccount/createAccountPage1.mi"
            >
              <span>Not a member? Join here</span>
              <Icon name="arrowRightNoLine" />
            </a>
          </div>
        </>
      }
    />
  );
};
